import axios from 'axios';
import { ContactFormData } from 'types/ContactFormData';

export const contact = async (data: ContactFormData) => {
  const baseUrl = process.env.REACT_APP_GAME_API_BACKEND_API ?? '';

  await axios.post(`${baseUrl}/contact`, data);
};
